import * as React from 'react';
import { Button, Typography } from '@/components/common';

export interface SubmitAnywayPopoverProps {
	isSubmitting?: boolean;
	onBack: () => void;
	onSubmit: () => void;
}

export const SubmitAnywayPopover: React.FC<SubmitAnywayPopoverProps> = ({
	isSubmitting = false,
	onBack,
	onSubmit,
}) => {
	return (
		<div
			role="dialog"
			aria-modal="true"
			aria-labelledby="submit-anyway-title"
			className="w-full max-w-[384px] rounded-[32px] bg-white py-8 px-8 flex flex-col gap-6 shadow-shadow2"
		>
			<div className="flex flex-col gap-3">
				<Typography
					type="semibold-16"
					id="submit-anyway-title"
					className="text-left"
				>
					Note:
				</Typography>
				<Typography type="regular-14" className="text-gray-35 !text-left">
					It is very likely that a lawyer will contact you to verify this
					information.
				</Typography>
			</div>
			<div className="flex items-center justify-between gap-3">
				<Button
					type="button"
					size="fit"
					decoration="secondary"
					label="Back"
					disabled={isSubmitting}
					className="!h-[30px]"
					onClick={onBack}
				/>
				<Button
					type="button"
					size="fit"
					decoration="primary"
					label="Submit"
					loading={isSubmitting}
					disabled={isSubmitting}
					className="!h-[30px]"
					onClick={onSubmit}
				/>
			</div>
		</div>
	);
};

export default SubmitAnywayPopover;
